<p class="mb-3">
  Il seriale <strong>{{ serialNumber }}</strong>
  <span *ngIf="productName"> ({{ productName }})</span> è in riparazione presso il fornitore (casa
  madre). Cosa sta rientrando?
</p>

<div class="field-radiobutton mb-2">
  <p-radioButton
    name="repairMode"
    value="same"
    [(ngModel)]="mode"
    inputId="repair_same"></p-radioButton>
  <label
    for="repair_same"
    class="ml-2"
    >Lo stesso seriale ({{ serialNumber }}), riparato</label
  >
</div>
<div class="field-radiobutton mb-3">
  <p-radioButton
    name="repairMode"
    value="replaced"
    [(ngModel)]="mode"
    inputId="repair_replaced"></p-radioButton>
  <label
    for="repair_replaced"
    class="ml-2"
    >Un seriale diverso: il fornitore ha sostituito l'apparato</label
  >
</div>

<div
  *ngIf="mode === 'replaced'"
  class="mb-3">
  <label class="block mb-1 font-semibold">Nuovo seriale *</label>
  <input
    pInputText
    type="text"
    class="w-full"
    [formControl]="newSerial"
    placeholder="Inserisci il seriale che rientra..."
    (keydown.enter)="confirm()" />
  <small
    class="p-error block mt-1"
    *ngIf="newSerial.value && sameAsOld"
    >Il nuovo seriale coincide con quello spedito: scegli "lo stesso seriale".</small
  >
  <small
    class="block mt-2"
    *ngIf="!alreadyReplacedBy">
    Il nuovo seriale entrerà in magazzino con il rientro (di manutenzione) e sostituirà quello
    spedito: verrà generata la consegna di sostituzione verso il cliente e il referente del ticket.
    Il seriale originale resterà nello storico come sostituito.
  </small>
  <small
    class="block mt-2"
    *ngIf="alreadyReplacedBy">
    Il cliente ha già ricevuto il seriale <strong>{{ alreadyReplacedBy }}</strong> in sostituzione di
    questo: il nuovo seriale entrerà in magazzino con il rientro e non verrà generata nessuna
    consegna. Il seriale originale resterà nello storico come sostituito dal fornitore.
  </small>
</div>

<div class="modal-footer">
  <div class="flex justify-content-between">
    <p-button
      (onClick)="close()"
      label="Annulla"
      [text]="true"
      styleClass="butt red"
      [rounded]="true"></p-button>
    <p-button
      label="Conferma"
      [disabled]="!canConfirm"
      (onClick)="confirm()"
      styleClass="butt"
      [rounded]="true"></p-button>
  </div>
</div>
